const setGraphData_newproject = payload => {
  return {
    type: "setGraphData_newproject",
    payload
  };
};
export default setGraphData_newproject;
